export default __webpack_public_path__ + "static/media/team.ab6ca243.png";